import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout } from 'antd';
import PlannedMaintenanceScheduleForm from '../planned_maintenance_schedule_form/PlannedMaintenanceScheduleForm';
import { NewPage } from '../new_page/NewPage';
import { goBackLink, recursiveRemovePreserve } from '../../utils/HistoryUtils';

const queryString = require('qs');
const { Content } = Layout;

class NewPlannedMaintenanceSchedulePage extends React.Component<any, any> {
	render() {
		const { history, userType, location } = this.props;
		return [
			<NewPage
				title="New Planned Maintenance Schedule"
				formComponentProps={{
					formData: {},
					onSuccess: (rec) => {
						const defaultUrl = `/${userType}/plannedMaintenance/detail/${encodeURIComponent(
							rec.title
						)}/${rec.frequency}/${rec.plannedMaintenanceTemplateId}/${
							rec.basedOn ? rec.basedOn : 'location'
						}`;
						const backLink = goBackLink(location, defaultUrl);
						const [path, params] = backLink.split('?');
						const urlSearchParams = queryString.parse(params);
						history.push(`${path}?${recursiveRemovePreserve(urlSearchParams)}`);
					},
				}}
				fetching={false}
				FormComponent={PlannedMaintenanceScheduleForm}
			/>,
		];
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
});
const mapDispatchToProps = (dispatch) => ({});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(NewPlannedMaintenanceSchedulePage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
